export default __webpack_public_path__ + "static/media/freeCreditDisplayIcon.ff77eb5d.svg";